import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { Fragment, useCallback, useMemo } from 'react';
import { useFieldArray, useWatch } from 'react-hook-form';
import Icon from '@mdi/react';
import { mdiDeleteSweep } from '@mdi/js';
import { Operator } from '../api/generated';
import { defineStyles, theme } from '../theme';
import { AddOrConditionButton } from './buttons/AddOrConditionButton';
import { FilterOrCondition } from './FilterOrCondition';
import { OrChip } from './FilterLogicChips';
import { getAnyFieldHasDuplicityOperator, getAnyFieldIsEmpty } from './helpers';
const styles = defineStyles({
    root: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        rowGap: 1,
        height: 'fit-content',
        my: 1,
        paddingInline: 1,
        paddingTop: 5,
        paddingBottom: 2,
        borderRadius: 2,
        boxSize: 'border-box',
        border: `1px solid ${theme.vars.palette.border.light}`,
    },
    removeGroupButton: {
        position: 'absolute',
        top: 4,
        right: 8,
    },
    rootDisabled: {
        backgroundColor: theme.vars.palette.grey[200],
    },
    rootActive: {
        backgroundColor: theme.vars.palette.grey[50],
    },
    orBox: {
        '& .MuiButtonBase-root': {
            width: '100%',
            justifyContent: 'flex-start',
            '& .MuiButton-startIcon': {
                ml: 0.5,
            },
        },
    },
    separatorWrapper: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        gap: 1,
    },
    separatorLine: {
        flex: 1,
        borderTop: `1px solid ${theme.vars.palette.divider}`,
    },
});
export function FilterAndCondition({ andConditionsIndex, removeParent, canRemoveAndBlock = true, field, filterColumns, enableAutocomplete, }) {
    const { append, fields, remove } = useFieldArray({
        name: `andConditions.${andConditionsIndex}.orConditions`,
    });
    const handleAddOrCondition = useCallback(() => append({
        field: '',
        operator: undefined,
    }), [append]);
    const orConditions = useWatch({
        name: `andConditions.${andConditionsIndex}.orConditions`,
    });
    const shouldDisableOr = useMemo(() => {
        const anyFieldHasDuplicityOperator = getAnyFieldHasDuplicityOperator(orConditions);
        const anyFieldIsEmpty = getAnyFieldIsEmpty(orConditions);
        return anyFieldHasDuplicityOperator || anyFieldIsEmpty;
    }, [orConditions]);
    return (_jsxs(Box, { sx: {
            ...styles.root,
            ...(field.fixed ? styles.rootDisabled : styles.rootActive),
        }, children: [!field.fixed && canRemoveAndBlock && (_jsx(IconButton, { size: "small", onClick: removeParent, sx: styles.removeGroupButton, children: _jsx(Icon, { path: mdiDeleteSweep, size: 1 }) })), fields.map((orField, orConditionsIndex) => (_jsxs(Fragment, { children: [_jsx(FilterOrCondition, { andConditionsIndex: andConditionsIndex, fixed: field.fixed, filterColumns: filterColumns, showRemoveButton: fields.length > 1, onDeleteClick: () => remove(orConditionsIndex), onFilterClick: handleAddOrCondition, orConditionsIndex: orConditionsIndex, disabledOperators: fields?.length > 1 ? [Operator.Duplicity] : [], enableAutocomplete: enableAutocomplete }), orConditionsIndex < fields.length - 1 && (_jsxs(Box, { sx: styles.separatorWrapper, children: [_jsx(Box, { sx: styles.separatorLine, "aria-hidden": true }), _jsx(OrChip, {}), _jsx(Box, { sx: styles.separatorLine, "aria-hidden": true })] }))] }, orField.id))), !field.fixed && (_jsx(Box, { sx: styles.orBox, children: _jsx(AddOrConditionButton, { disabled: field.fixed || shouldDisableOr, onClick: () => {
                        append({
                            field: '',
                            operator: undefined,
                        });
                    } }) }))] }));
}
//# sourceMappingURL=FilterAndCondition.js.map